/**
 * @flow
 * @relayHash 1c4455722772914ee0deb379579ae24a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type cart_viewer$ref = any;
export type cart_QueryVariables = {| |};
export type cart_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: cart_viewer$ref,
  |},
|};
*/


/*
query cart_Query {
  viewer {
    ...cart_viewer
    id
  }
}

fragment cart_viewer on Viewer {
  selected_currency_rate
  cart {
    id
    license_line_items {
      id
      amount
      discount_amount
      track {
        id
        internal_id
        title
        added_to_cart
        slug
        assets {
          id
          version
          type
          file_format
          path
          metadata
        }
        artist {
          id
          name
          slug
          assets {
            id
            version
            type
            file_format
            path
            metadata
          }
        }
        terms {
          edges {
            node {
              id
              is_highlighted
              name
              parent_id
              taxonomy {
                id
                internal_id
                name
              }
            }
          }
        }
      }
      license {
        id
        usages {
          id
          license_id
          air_date
          components {
            id
            component_id
            name
            type
          }
        }
      }
    }
    total
  }
  profile {
    id
    user_id
    email
    external_provider
    first_name
    is_new_user
    ga_account_goal_sent
    last_name
    picture
    company_name
    company_size {
      name
      id
    }
    industry {
      name
      id
    }
    job_type {
      name
      id
    }
  }
  selected_currency
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    v3,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = [
  v5,
  v0
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "cart_Query",
  "id": null,
  "text": "query cart_Query {\n  viewer {\n    ...cart_viewer\n    id\n  }\n}\n\nfragment cart_viewer on Viewer {\n  selected_currency_rate\n  cart {\n    id\n    license_line_items {\n      id\n      amount\n      discount_amount\n      track {\n        id\n        internal_id\n        title\n        added_to_cart\n        slug\n        assets {\n          id\n          version\n          type\n          file_format\n          path\n          metadata\n        }\n        artist {\n          id\n          name\n          slug\n          assets {\n            id\n            version\n            type\n            file_format\n            path\n            metadata\n          }\n        }\n        terms {\n          edges {\n            node {\n              id\n              is_highlighted\n              name\n              parent_id\n              taxonomy {\n                id\n                internal_id\n                name\n              }\n            }\n          }\n        }\n      }\n      license {\n        id\n        usages {\n          id\n          license_id\n          air_date\n          components {\n            id\n            component_id\n            name\n            type\n          }\n        }\n      }\n    }\n    total\n  }\n  profile {\n    id\n    user_id\n    email\n    external_provider\n    first_name\n    is_new_user\n    ga_account_goal_sent\n    last_name\n    picture\n    company_name\n    company_size {\n      name\n      id\n    }\n    industry {\n      name\n      id\n    }\n    job_type {\n      name\n      id\n    }\n  }\n  selected_currency\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "cart_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "cart_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "cart_Query",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_currency_rate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              v0,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "license_line_items",
                "storageKey": null,
                "args": null,
                "concreteType": "LicenseLineItem",
                "plural": true,
                "selections": [
                  v0,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "amount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "discount_amount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "track",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TrackSearchResult",
                    "plural": false,
                    "selections": [
                      v0,
                      v1,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "added_to_cart",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      v4,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "artist",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Artist",
                        "plural": false,
                        "selections": [
                          v0,
                          v5,
                          v2,
                          v4
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "terms",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TaxonomyTermConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "TaxonomyTermEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "TaxonomyTerm",
                                "plural": false,
                                "selections": [
                                  v0,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "is_highlighted",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  v5,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "parent_id",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "taxonomy",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Taxonomy",
                                    "plural": false,
                                    "selections": [
                                      v0,
                                      v1,
                                      v5
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "license",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "StandardLicense",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "usages",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StandardLicenseUsage",
                        "plural": true,
                        "selections": [
                          v0,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "license_id",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "air_date",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "components",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StandardLicenseUsageComponent",
                            "plural": true,
                            "selections": [
                              v0,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "component_id",
                                "args": null,
                                "storageKey": null
                              },
                              v5,
                              v3
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "total",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ga_account_goal_sent",
                "args": null,
                "storageKey": null
              },
              v0,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "external_provider",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "first_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "is_new_user",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "user_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "picture",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "company_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "company_size",
                "storageKey": null,
                "args": null,
                "concreteType": "CompanySize",
                "plural": false,
                "selections": v6
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "industry",
                "storageKey": null,
                "args": null,
                "concreteType": "Industry",
                "plural": false,
                "selections": v6
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "job_type",
                "storageKey": null,
                "args": null,
                "concreteType": "JobType",
                "plural": false,
                "selections": v6
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "selected_currency",
            "args": null,
            "storageKey": null
          },
          v0
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'b0d7bec8b85f17bc5854b4bee7b4e18b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/cart_Query.graphql.js